# EXPERIMENT: teamMembersTabLayoutV1
# This component is currently only being used for
# the new variation in adding members to a team
$ = require 'jquery'
AdViews = require 'views/ads/ad-views'
Alerts = require 'views/lib/alerts'
ApiAjax = require 'network/api-ajax'
ApiError = require 'network/api-error'
Auth = require 'db/auth'
BulkAddOrgMembersView = require 'views/organization/bulk-add-org-members-view-react'
DisplayInvitationLinkView = require 'views/invitation-link/display-invitation-link-view'
Invitation = require 'models/invitation'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
l = require 'lib/localize'
localizeServerError = require 'lib/localize-server-error'
inviteMembersTemplate = require 'views/templates/invite_members'
Member = require 'models/member'
MemberAddView = require 'views/member/member-add-view'
MemberSearchView = require 'views/search/member-search-view'
OrganizationLinkGAHelperView = require 'views/organization/organization-link-ga-helper-view'
OrgFeatures = require 'data/org-features'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
containsValidUrl = require 'lib/util/url/contains-valid-url'
View = require 'view'
_ = require 'underscore'
mixin = require 'lib/mixin'
templates = require 'views/internal/templates'
inviteAddNameTemplate = require 'views/templates/invite_add_name'
track = require 'debug/track'
React = require 'react'

module.exports = class InviteTeamMembersView extends View
  mixin MemberSearchView, MemberAddView, DisplayInvitationLinkView, @

  viewTitleKey: 'add members'

  initialize: ->
    @savedSearch = ""
    return

  events:

    # send invites
    'click .js-search-results .js-select-member': 'addMember'
    'paste .js-search-input': 'searchPaste'

    # remove invite
    'click .js-remove-invitation': 'removeInvitation'

    # send email invite to new email address
    'click .js-send-email-invite': 'sendEmailInvite'
    'submit .js-email-data': 'sendEmailInvite'

    # etc
    'click .js-open-option': 'openOption'
    'mouseenter .js-select-member': 'hoverMember'

    # invitation links
    'click .js-show-invitation-link': 'showInvitationLink'
    'click .js-invitation-link': 'clickInvitationLink'
    'click .js-deactivate-link': 'deactivateInvitationLink'
    'click .js-copy-link': 'copyInvitationLink'

    # bulk add
    'click .js-bulk-add-members': 'showBulkAddView'

    # link google apps
    'click .js-link-google-apps': 'startLinkingGoogleApps'

  render: ->

    data = {}

    data.canInviteMembers = true
    data.canAddMembers = true
    data.placeholder = l('add member placeholder')
    data.isPerUser = OrgFeatures.isPerUser(@model.get('products'))
    data.perUserPrice = OrgFeatures.getPrice(@model.get('products'))?.toFixed(2)
    data.isYearly = OrgFeatures.getInterval(@model.get('products')) == 'yearly'
    data.isMonthly = OrgFeatures.getInterval(@model.get('products')) == 'monthly'
    data.canLinkGoogleApps = @model.isFeatureEnabled('googleApps') && (!@model.get('prefs').associatedDomain || @googleAppsFetchFailed) && @model.editable()

    @$el.html(inviteMembersTemplate(data))

    if (adView = AdViews.addMemberToOrganizationAd(Auth.me(), @model))?
      @$('.js-ad').html(@subview(adView, @model).render().el)

    @setTimeout =>
      @input = @$('.js-search-input')
      @input
        .click((e) -> Util.stop(e))
        .keyup(@debounce(@search, 500).bind(@))
        .keydown(@keydownEvent.bind(@))
        .focus()
      if @savedSearch
        @input.val(@savedSearch)
        @search()
        @savedSearch = ''

    , 10

    @lastSearch = ''
    @loadingEl = @$('.js-loading')
    @helperEl = @$('.js-helper')

    @

  # search
  searchPaste: ->
    @loadingEl.show()
    @input.keyup()

  search: (e) ->
    # We don't want to use key codes here since this is a debounced event
    return if @lastSearch? && @lastSearch == @input.val()
    @lastSearch = @input.val()

    search = @input.val().toLowerCase().trim()

    if search == ''
      @clearSearchResults()
      return

    @loadingEl.show()

    ApiAjax
      url: '/1/search/members/'
      type: 'get'
      data:
        idOrganization: @model.id
        query: search
      dataType: 'json'
      success: (data) =>
        @renderSearchResults(search, data)
    return

  keydownEvent: (e) ->
    key = Keyboard.getKey(e)

    if key == Keys.Enter

      if @$('.js-search-results .js-list .selected .js-select-member').length > 0
        Util.stop(e)
        @$('.js-search-results .js-list .selected:first .js-select-member').click()

      else if @$('.js-search-results .js-list .email-invite').length > 0
        Util.stop(e)
        @$('.email-invite:first').click()

    # navigate menu list
    else if key in [Keys.ArrowUp, Keys.ArrowDown]
      Util.stop(e)
      Util.navMenuList(@$('.js-search-results .js-list'), 'li', key)

    return

  _handleError: (res) ->
    message = localizeServerError(res)

    Alerts.showLiteralText(message, 'error', 'alert', 3000)
    track("Invitations", "Error: #{ message }")

    @input.focus().select()

  addMember: (e) ->
    Util.stop(e)

    return if $(e.target).closest('.item.disabled').length > 0

    @clearSearchResults()

    idMember = $(e.target).closest('.js-select-member').attr('idMember')
    member = @modelCache.get('Member', idMember)

    ApiAjax
      url: "/1/organization/#{@model.id}/members/#{idMember}"
      type: 'put'
      data: { type: 'normal' }
      dataType: 'json'
      success: (data) =>
        if !data.token? && !@model.memberList.find((member) => member.id == idMember)
          #the member was just added
          @model.memberList.add(member)
          track("Invitations", "Add Member to Organization", "Role: Member")
      error: @_handleError.bind(@)

    return

  renderEmailInviteToSearchResults: (data) ->
    puncSpacePattern = /[\s\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/
    puncPattern = /[\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/

    fullName = _.compact(Util.removeDomainFromEmailAddress(data.email).split(puncSpacePattern)).join(' ').replace(puncPattern, '')
    data.fullName = Util.toTitleCase(fullName)
    data.modelType = 'Organization'

    @$('.js-uninvited-search-results').append inviteAddNameTemplate(data)
    .show()

  sendEmailInvite: (e) ->
    Util.stop(e)

    $sendButton = @$('.js-send-email-invite')
    # The email is already being sent
    if $sendButton.attr('disabled')?
      return

    $name = @$('.js-email-data .js-full-name')
    name = $name.val().trim()

    if !Util.validName(name)
      Util.setCaretAtEnd($name)
      $('.js-name-error').show()
      return
    else if containsValidUrl(name)
      # Urls are not allowed as member names
      Util.setCaretAtEnd($name)
      $('.js-name-error-url').show()
      return

    data =
      fullName: name
      email: @$('.js-email-data .js-email').val().trim()
      type: 'normal'

    # Disable the button while we're sending the invite
    $sendButton.attr('disabled', 'disabled')

    ApiAjax
      url: "/1/organizations/#{@model.id}/members"
      type: 'put'
      dataType: 'json'
      data: data
      success: (data) =>
        member = new Member(data, { @modelCache })
        if !@model.memberList.get(member.id)
          @model.memberList.add(member)
        track("Invitations", "Send Email Org Invite to New Member", "Role: #{data.type}")

        $sendButton.removeAttr('disabled')
        PopOver.hide()
      error: @_handleError.bind(@)

    return

  clearSearchResults: ->
    @helperEl.show()
    @lastSearch = ''
    @input.val('').focus().select()
    @$('.js-uninvited-search-results').hide().empty()
    $('.js-search-results').hide()

  # remove invite
  removeInvitation: (e) ->
    id = $(e.currentTarget).closest('.invitation').data('id')

    Invitation::delete
      model: @model
      idInvitation: id
      success: =>
        track("Invitations", "Delete Organization Invite")
        @search

    Util.setCaretAtEnd(@input[0])
    return

  # perms
  canRemoveInvitation: (invitation) -> invitation.get('idMemberInviter') == Auth.myId() || @model.owned()

  willBePushedDown: ->
    @savedSearch = @input.val()

  willBePopped: ->
    @savedSearch = ""

  showBulkAddView: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @el
      getViewTitle: -> l ['view title', 'add members']
      reactElement: React.createElement BulkAddOrgMembersView, {
        key: 'bulk add members'
        @model
      }

  startLinkingGoogleApps: (el) ->
    track("Organization View", "Members Page", "Start Linking Google Apps Domain")

    PopOver.pushView
      view: OrganizationLinkGAHelperView
      options: { @model, @modelCache }



// WEBPACK FOOTER //
// ./app/scripts/views/organization/invite-team-members-view.coffee